import HomeOuvidoria from './Home'
import GestaoConflito from '@/screens/ouvidoria/GestaoConflito'
import Conflito from '@/screens/ouvidoria/Conflito'

export const items = [
  {
    path: 'home',
    name: 'ouvidoria/home',
    component: HomeOuvidoria,
    meta: {
      isPublic: false,
      routeGroup: 'ouvidoria/home'
    }
  },
  {
    path: '/ouvidoria/gestao-conflitos',
    name: 'ouvidoria/gestao-conflitos',
    component: GestaoConflito,
    meta: {
      isPublic: false,
      routeGroup: 'ouvidoria/gestao-conflitos'
    }
  },
  {
    path: '/ouvidoria/conflito',
    name: 'ouvidoria/conflito/novo',
    component: Conflito,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ouvidoria/gestao-conflitos'
    }
  },
  {
    path: '/ouvidoria/conflito/:id',
    name: 'ouvidoria/conflito/editar',
    component: Conflito,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ouvidoria/gestao-conflitos'
    }
  }
]



// WEBPACK FOOTER //
// ./src/screens/ouvidoria/config.js